import { handleErrors, paginatedRequest, simplePostRequest } from "../../../shared/src/API/baseAPI";
import { createUserCard } from "../../../shared/src/components/UserCard/user-info";
import { isFriend } from "../../../shared/src/UIController/user";
import { showAlert } from "../../../shared/src/Util/alerts";
import { getCurrentUser } from "../../../shared/src/Util/helper";

document.addEventListener('DOMContentLoaded', () => {
    initializeProfile();
});

function initializeProfile() {
    const isOwn = isOwnProfile();
    const wrapper = document.getElementById('card-wrapper');
    const profileCard = document.getElementById('profile-card');
    
    createProfileCard(profileCard, profile, isOwn);
    profileCard.innerHTML += isOwn ? `
        <div class="flex gap-2 w-full">
            <a href='/account#data'
                    class="btn btn-primary flex-1" 
                    title="${t('profile.editProfile')}">
                <i class="fa-solid fa-gear"></i>
                ${t('profile.editProfile')}
            </a>
        </div>
    ` : `
        <div class="flex gap-2 w-full">
            ${!isFriend(profile) ? `
                <button id="add-friend-btn" 
                        class="btn btn-primary flex-1 max-w-96" 
                        onclick="App.profile.handleFriendAction('${profile.username}', '${profile.id}', false, 'add-friend-btn')"
                        title="${t('profile.addFriend')}">
                    <i class="fa-solid fa-user-plus"></i>
                    ${t('profile.addFriend')}
                </button>
            ` : ``}
            <div class="dropdown dropdown-end">
                <button tabindex="0" class="btn" title="${t('profile.options')}">
                    <i class="fa-solid fa-ellipsis"></i>
                </button>
                <ul tabindex="0" class="menu dropdown-content bg-base-100 rounded-box z-[1] w-52 p-2 shadow-lg border border-base-300 mt-2">
                    ${isFriend(profile) ? `
                        <li id="friend-action-${profile.id}"><a onclick="App.profile.handleFriendAction('${profile.username}', '${profile.id}', false)">
                            <i class="fa-solid fa-user-minus"></i>
                            ${t('profile.removeFriend')}
                        </a></li>
                    ` : `
                        <li id="friend-action-${profile.id}"><a onclick="App.profile.handleFriendAction('${profile.username}', '${profile.id}', true)">
                            <i class="fa-solid fa-user-plus"></i>
                            ${t('profile.addFriend')}
                        </a></li>
                    `}
                    <li><a onclick='App.profile.handleBlockUser("${profile.username}")'>
                        <i class="fa-solid fa-user-large-slash"></i>
                        ${t('profile.blockUser')}
                    </a></li>
                    <li><a onclick='App.profile.handleReportUser("${profile.username}","${profile.id}")' class="text-error">
                        <i class="fa-solid fa-flag"></i>
                        ${t('profile.reportUser')}
                    </a></li>
                </ul>
            </div>
        </div>
    `;

    if (profile.bio || isOwn) {
        createBioSection(wrapper, profile, isOwn);
    }

    createStatsSection(wrapper);
    
    if (profile.friendsCount > 0) {
        createFriendsPreview(wrapper);
    }
}

function createProfileCard(wrapper, user) {
    const subtext = `@${user.username}`;

    createUserCard(wrapper, user, {
        position: 'bottom',
        show: {
            avatar: true,
            name: true,
            hover: true,
        },
        size: 'size-24',
        subtext: subtext,
    });
}

function createStatsSection(wrapper) {
    const statsCard = document.createElement('div');
    statsCard.className = 'card bg-base-100 shadow-xl mt-6';
    
    statsCard.innerHTML = `
        <div class="card-body">
            <h2 class="card-title">
                <i class="fa-solid fa-chart-simple"></i>
                ${t('profile.statistics')}
            </h2>
            <div class="stats stats-vertical lg:stats-horizontal shadow w-full mt-2">
                <div class="stat">
                    <div class="stat-figure text-primary">
                        <i class="fa-solid fa-users text-2xl"></i>
                    </div>
                    <div class="stat-title">${t('profile.friends')}</div>
                    <div class="stat-value text-primary">${profile.friendsCount || 0}</div>
                    <div class="stat-desc">
                        ${profile.incomingRequests > 0 
                            ? t('profile.pendingRequests', { count: profile.incomingRequests })
                            : t('profile.noPendingRequests')
                        }
                    </div>
                </div>
                
                <div class="stat">
                    <div class="stat-figure text-secondary">
                        <i class="fa-solid fa-calendar-days text-2xl"></i>
                    </div>
                    <div class="stat-title">${t('profile.memberSince')}</div>
                    <div class="stat-value text-secondary text-lg">${formatMemberSince(profile.createdAt)}</div>
                    <div class="stat-desc">${getTimeAgo(profile.createdAt)}</div>
                </div>
                
                <div class="stat">
                    <div class="stat-figure ${profile.status === 'online' ? 'text-success' : 'text-base-300'}">
                        <i class="fa-solid fa-circle text-xl"></i>
                    </div>
                    <div class="stat-title">${t('profile.status')}</div>
                    <div class="stat-value text-lg">${t(`profile.${profile.status || 'offline'}`)}</div>
                    <div class="stat-desc">
                        ${profile.isPublic 
                            ? `<i class="fa-solid fa-globe"></i> ${t('profile.publicProfile')}`
                            : `<i class="fa-solid fa-lock"></i> ${t('profile.privateProfile')}`
                        }
                    </div>
                </div>
            </div>
        </div>
    `;
    
    wrapper.appendChild(statsCard);
}

function createFriendsPreview(wrapper) {
    const friendsCard = document.createElement('div');
    friendsCard.className = 'card bg-base-100 shadow-xl mt-6';
    
    friendsCard.innerHTML = `
        <div class="card-body">
            <h2 class="card-title">
                <i class="fa-solid fa-users"></i>
                ${t('profile.friends')}
                <span class="badge badge-primary">${profile.friendsCount}</span>
            </h2>
            <div id="friends-container" class="mt-4">
                <div class="flex items-center justify-center py-8">
                    <span class="loading loading-spinner loading-lg"></span>
                </div>
            </div>
            ${profile.friendsCount > 6 ? `
                <div class="card-actions justify-end mt-4">
                    <button onclick="App.profile.viewAllFriends('${profile.username}')" class="btn btn-primary btn-sm">
                        ${t('profile.viewAllFriends')}
                    </button>
                </div>
            ` : ''}
        </div>
    `;
    
    wrapper.appendChild(friendsCard);
    loadFriendsPreview(profile.username);
}

function createBioSection(wrapper, user, isOwn) {
    const bioCard = document.createElement('div');
    bioCard.className = 'card bg-base-100 shadow-xl mt-6';
    
    bioCard.innerHTML = `
        <div class="card-body">
            <h2 class="card-title">
                <i class="fa-solid fa-info-circle"></i>
                ${t('profile.about')}
            </h2>
            <div class="prose max-w-none">
                ${user.bio || (isOwn ? `<p class="text-base-content/70">${t('profile.noBio')}</p>` : `<p class="text-base-content/70">${t('profile.userNoBio')}</p>`)}
            </div>
            ${isOwn ? `
                <div class="card-actions justify-end mt-4">
                    <a href='/account#data' class="btn btn-sm">
                        <i class="fa-solid fa-pen"></i>
                        ${t('profile.editBio')}
                    </a>
                </div>
            ` : ''}
        </div>
    `;
    
    wrapper.appendChild(bioCard);
}

function loadFriendsPreview(username) {
    paginatedRequest(`/api/v1/users/${username}/friends/:page`, '', displayFriends);
}

function displayFriends(res) {
    if (res.error) {
        handleErrors(res);
        return;
    }

    const data = res.data;
    const container = document.getElementById('friends-container');
        
    if (!container) return;
    
    if (data.friends && data.friends.length > 0) {
        container.innerHTML = '';
        const friendsGrid = document.createElement('div');
        friendsGrid.className = 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3';
        
        data.friends.slice(0, 6).forEach(friend => {
            const friendCard = document.createElement('div');
            friendCard.className = 'flex items-center gap-3 p-3 rounded-lg hover:bg-base-200 transition-colors border border-base-300 relative';
            
            const isFriendWithUser = typeof alertUser !== 'undefined' && alertUser.friends && alertUser.friends.includes(friend.id);
            const isOwnProfile = typeof alertUser !== 'undefined' && alertUser.id === friend.id;
            
            // Add friend action button HTML
            const actionButtonHTML = !isOwnProfile ? `
                <button 
                    id="friend-action-${friend.id}"
                    onclick="App.profile.handleFriendAction('${friend.username}', ${friend.id}, ${isFriendWithUser})"
                    class="btn btn-sm ${isFriendWithUser ? 'btn-ghost' : 'btn-primary'} absolute top-2 right-2 z-10"
                    title="${isFriendWithUser ? t('profile.removeFriend') : t('profile.addFriend')}">
                    <i class="fa-solid fa-user-${isFriendWithUser ? 'minus' : 'plus'}"></i>
                </button>
            ` : '';
            
            friendsGrid.appendChild(friendCard);
            
            createUserCard(friendCard, friend, {
                show: {
                    hover: true
                },
                subtext: '@' + friend.username,
                visibleSlotHTML: actionButtonHTML
            });
        });
        
        container.appendChild(friendsGrid);
    } else {
        container.innerHTML = `<p class="text-center text-base-content/70 py-4">${t('profile.noFriends')}</p>`;
    }
}

// Add this handler function
export function handleFriendAction(username, friendId, isFriend, id = null) {
    
    if (getCurrentUser() == null) {
        showAlert(t('errors.notLoggedIn'), 'error');
        return;
    }

    if (isFriend) {
        if (confirm(t('profile.confirmRemoveFriend'))) {
            simplePostRequest(`/api/v1/users/${username}/unfollow`, id? id : `friend-action-${friendId}`, handleFriendRemoved)
        }
    } else {
        simplePostRequest(`/api/v1/users/${username}/follow`,  id? id : `friend-action-${friendId}`, handleFriendAccepted);
    }
}

function handleFriendAccepted(res) {
    if (res.error) {
        handleErrors(res);
        return;
    }
    
    const friendId = res.id;
    const username = res.username
    const button = document.getElementById(`friend-action-${friendId}`);

    showAlert(t('profile.friendRequestSent'), 'success');
    // Update button state
    button.className = 'btn btn-sm btn-ghost absolute top-2 right-2 z-10';
    button.innerHTML = '<i class="fa-solid fa-user-minus"></i>';
    button.title = t('profile.removeFriend');
    button.onclick = () => handleFriendAction(username, friendId, true);
    // Update alertUser.friends if exists
    if (typeof alertUser !== 'undefined' && alertUser.friends) {
        alertUser.friends.push(friendId);
    }
}

function handleFriendRemoved(res) {
    if (res.error) {
        handleErrors(res);
        return;
    }

    showAlert(t('profile.friendRemoved'), 'success');
    // Update button state
    button.className = 'btn btn-sm btn-primary absolute top-2 right-2 z-10';
    button.innerHTML = '<i class="fa-solid fa-user-plus"></i>';
    button.title = t('profile.addFriend');
    button.onclick = () => handleFriendAction(username, friendId, false);
    // Update alertUser.friends if exists
    if (typeof alertUser !== 'undefined' && alertUser.friends) {
        alertUser.friends = alertUser.friends.filter(id => id !== friendId);
    }

}

function isOwnProfile() {
    return typeof alertUser !== 'undefined' && alertUser?.username === profile.username;
}

export function sendFriendRequest(username, buttonId = null) {
    if (typeof username !== 'string' || username.length < 3) {
        showAlert(t('profile.errors.invalidUsername'), 'error');
        return;
    }

    const button = buttonId ? document.getElementById(buttonId) : null;
    
    simplePostRequest(`/api/v1/users/${username}/follow`, buttonId, null)
}

function formatMemberSince(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString(undefined, { 
        year: 'numeric', 
        month: 'short' 
    });
}

function getTimeAgo(dateString) {
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays < 7) return t('profile.timeAgo.days', { count: diffDays });
    if (diffDays < 30) return t('profile.timeAgo.weeks', { count: Math.floor(diffDays / 7) });
    if (diffDays < 365) return t('profile.timeAgo.months', { count: Math.floor(diffDays / 30) });
    return t('profile.timeAgo.years', { count: Math.floor(diffDays / 365) });
}

export function handleBlockUser(username) {
    App.common.blockUser(username);
}

export function viewAllFriends(username) {
    showAlert(t('dev.soon'), 'info');
    //window.location.href = `/${username}/friends`;
}

export function handleReportUser(username, userId) {
    App.common.reportUser(username, userId);
};

export function handleMessage() {
    showAlert(t('dev.soon'), 'info');
}